module.exports = __webpack_public_path__ + "static/img/important6.3c010f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/important6.png
// module id = udfe
// module chunks = 1